<template>
  <AtomsLoaderUI v-if="isLoading" :isOpaque="loaderOpacity" />
</template>

<script setup lang="ts">
const isLoading = useLoaderState()
const loaderOpacity = useLoaderOpacity()
const route = useRoute()

if ((route.name! as string)?.includes('preview')) {
  isLoading.value = true
}

// Clear sticky loader left by PLP infinite-scroll (or other flows) on navigation.
watch(
  () => route.fullPath,
  () => {
    if ((route.name! as string)?.includes('preview')) return
    isLoading.value = false
  }
)
</script>
